import { type TranslationKey } from "~/helpers/common-helpers";

export const useTranslator = () => {
  const { $i18n } = useNuxtApp();

  const i18n = $i18n.global;

  return i18n.t<TranslationKey>;
};

export const useCountTranslator = () => {
  const { $i18n } = useNuxtApp();

  const i18n = $i18n.global;

  return (key: TranslationKey, count: number) => i18n.t<TranslationKey>(key, count);
};
